import { render, staticRenderFns } from "./CategoryProductData.vue?vue&type=template&id=69cac756&"
import script from "./CategoryProductData.vue?vue&type=script&lang=js&"
export * from "./CategoryProductData.vue?vue&type=script&lang=js&"
import style0 from "./CategoryProductData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports